import TreatmentAssignment from "../model/treatment/TreatmentAssignment";
import Treatment from "../model/treatment/Treatment";

export function byPosition(a1: TreatmentAssignment, a2: TreatmentAssignment) {
  if (a1.position === a2.position) {
    if (a1.treatment.name < a2.treatment.name) return -1;
    else if (a1.treatment.name > a2.treatment.name) return 1;
    else return 0;
  } else return a1.position - a2.position;
}

export function byAssignmentPosition(criteriaGroup: string, t1: Treatment, t2: Treatment) {
  return (
    (t1.assignments.find((it) => it.criteriaGroup.id === criteriaGroup)?.position ?? 0) -
    (t2.assignments.find((it) => it.criteriaGroup.id === criteriaGroup)?.position ?? 0)
  );
}
